import React, { useContext } from 'react';
import { Stack, Typography } from '@mui/material';
import { ReportContext } from '../../../common/reportContext';
import { emptyReport } from '../../../networking/analyses/report/Report';
import EditTextField from '../../../components/EditTextField/EditTextField';
import { RichTextView } from '../../../components/RichText';
import { useTranslation } from 'react-i18next';

interface BaseSummaryProps {
  title: string;
  content: string;
  setContent: (content: string) => void;
  editable?: boolean;
}

const BaseSummary = (props: BaseSummaryProps) => {
  const { t } = useTranslation();
  const { report } = useContext(ReportContext);
  const isReportSelected = report !== emptyReport;

  return (
    <Stack spacing={1} sx={{ width: '100%' }}>
      <Typography
        sx={{
          fontSize: '36px',
          color: 'text.primary'
        }}
      >
        {props.title}
      </Typography>
      {props.title === 'Treasury Services' && (
        <Typography
          sx={{
            color: 'text.primary',
            fontSize: '18px',
            fontWeight: 650
          }}
        >
          {t('common.cashVestAnalysisHeading')}
        </Typography>
      )}
      {props.editable != undefined ? (
        <EditTextField placeholder={isReportSelected ? "" : undefined} text={props.content} setText={props.setContent} />
      ) : (
        <RichTextView value={props.content} muiStyling={{ fontSize: '18px', color: 'text.primary' }} />
      )}
    </Stack>
  );
};

export default BaseSummary;
